const LocalDiagramDownloader = () => {

    var diagrams = ["asset","threat","risk","treatment","treatment_overview"]

    const saveGraphToFile = (diagram, diagram_id) => {
        try {
            var a = document.createElement('a');
            var graph = window.localStorage.getItem(diagram_id);
            var graphContent = new Blob([JSON.stringify(JSON.parse(graph), null, 2)], { type: 'text/plain' });
            a.href = URL.createObjectURL(graphContent);
            //a.download = "CORASDiagram.json";
            a.download = diagram + "_diagram_backup.json";
            a.click();
            a.remove();
        } catch (error) {
            console.log(error)
        }
    }

    const restoreDiagrams = () => {
        var paperid = "paper-holder"
        var graphid = "graph_"
        diagrams.forEach((diagram) => {
            var diagram_id = paperid + graphid + diagram;
            if (window.localStorage.getItem(diagram_id) !== null) {
                saveGraphToFile(diagram, diagram_id)
            } else {
                console.log("Diagram type", diagram, "is empty.")
            }
        })
    }

    return (
        <div>
            <p>If you have WIP diagrams from this site saved in your browser, click here to download them.</p>
            <button onClick={restoreDiagrams}>
                Download local diagrams
            </button>
        </div>
    )
} 

export default LocalDiagramDownloader